export default {
    'bagDetail.sy': '剩余',
    'bagDetail.sd': '锁定',
    'bagDetail.bcbzd': '补充包装袋',
    'bagDetail.bctip': '请在设备上完成补充后点击',
    'bagDetail.bxybc': '不需要补充',
    'bagDetail.qdtip': '确定补充后，包装袋剩余将改成80'
}